import React, { useState } from "react";
// @ts-expect-error Legacy modal does not provide TypeScript declarations.
import EmptyModal from "../../../modals/EmptyModal";
// @ts-expect-error Legacy confirmation form does not provide TypeScript declarations.
import DeleteConfirmationForm from "../../DeleteConfirmationForm";
import RecipeEditor from "./RecipeEditor";
import RecipeHeader from "./RecipeHeader";
import RecipeMessages from "./RecipeMessages";
import useProductRecipe from "./useProductRecipe";
interface Props {
  productId: number;
  productSellingUnit: number;
  productName?: string;
  active: boolean;
  onUnauthorized: () => void;
}
export default function ProductRecipeTab({
  productId,
  productSellingUnit,
  productName,
  active,
  onUnauthorized,
}: Props) {
  const model = useProductRecipe(
    productId,
    productSellingUnit,
    active,
    onUnauthorized
  );
  const [confirmRemove, setConfirmRemove] = useState(false);
  const remove = async () => {
    await model.remove();
    setConfirmRemove(false);
  };
  return (
    <section
      aria-label="Product recipe"
      className="rounded-xl border border-slate-200 bg-white"
    >
      <RecipeHeader
        {...model}
        productName={productName}
        hasRecipe={Boolean(model.recipe)}
        onRemove={() => setConfirmRemove(true)}
      />
      <div className="space-y-4 px-4 pt-4 sm:px-5">
        <RecipeMessages {...model} />
        {model.loaded && !model.loading && (
          <>
            {!model.canManage && (
              <p className="text-xs text-slate-500">
                You have read-only access to recipes.
              </p>
            )}
            {!model.productAvailable && (
              <p className="text-xs text-slate-500">
                This product is discontinued. Its recipe can be viewed or
                removed.
              </p>
            )}
            {model.editing ? (
              <RecipeEditor
                {...model}
                productSellingUnit={productSellingUnit}
              />
            ) : (
              <p className="pb-5 text-sm text-slate-500">
                No recipe configured for this product.
              </p>
            )}
          </>
        )}
      </div>
      <EmptyModal
        open={confirmRemove}
        setOpen={() => {
          if (!model.saving) setConfirmRemove(false);
        }}
        childComponent={
          confirmRemove ? (
            <DeleteConfirmationForm
              title="Remove recipe"
              message="Remove this product’s recipe and all its ingredient lines? Ingredient products will be kept."
              buttonMessage="Remove recipe"
              hideReason
              inProgress={model.saving}
              confirmAction={remove}
              setOpen={() => setConfirmRemove(false)}
            />
          ) : null
        }
      />
    </section>
  );
}
